import { render } from "./PR52-05122025.vue?vue&type=template&id=2a09bf60"
import script from "./PR52-05122025.vue?vue&type=script&lang=js"
export * from "./PR52-05122025.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__